import { useTranslation } from "react-i18next";
import { useAgreementData } from "../../hooks";
import { AgreementDataSection, AgreementFields } from "../shared";
import { CollapsibleSection } from "@/components/CollapsibleSection";

const b2bFields: AgreementFields = [
  { key: "company_tax_identification_number" },
  { key: "company_name" },
  { key: "company_postal_code" },
  { key: "company_city" },
  { key: "company_street_name", type: "textarea" },
  { key: "company_street_number" },
  { key: "company_apartment_number" },
] as const;

export const AgreementB2BQuestionnaireSection = () => {
  const { t } = useTranslation();
  const { draft_b2b, b2b, agreement } = useAgreementData();

  if (!agreement.is_b2b_agreement) {
    return null;
  }

  return (
    <CollapsibleSection title={t("agreements.b2bQuestionnaire.title")}>
      <AgreementDataSection
        title=""
        fields={b2bFields}
        draftData={draft_b2b}
        confirmedData={b2b}
        translationPrefix="questionnaires.form.fields"
      />
    </CollapsibleSection>
  );
};
